import { render, staticRenderFns } from "./delay.vue?vue&type=template&id=bcbca942"
import script from "./delay.vue?vue&type=script&lang=js"
export * from "./delay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports